export default "__VITE_ASSET__mqO74LfE__"